import { css } from '@emotion/react'

export const styles = css`
  @keyframes shrink-bounce {
    0% {
      transform: scale(1);
    }
    33% {
      transform: scale(0.75);
    }
    100% {
      transform: scale(1);
    }
  }

  @keyframes checkbox-check {
    0% {
      width: 0;
      height: 0;
      border-color: #fff;
      transform: translate3d(0, 0, 0) rotate(45deg);
    }
    33% {
      width: 0.3em;
      height: 0;
      transform: translate3d(0, 0, 0) rotate(45deg);
    }
    100% {
      width: 0.3em;
      height: 0.6em;
      border-color: #fff;
      transform: translate3d(0, -0.6em, 0) rotate(45deg);
    }
  }

  .dropdown {
    width: 100%;
    background-color: white;

    .dropdown-trigger {
      display: inline-flex;
      align-items: center;
      width: 100%;
      box-sizing: border-box;
      border: 1px solid #25515b !important;

      & > span:after {
        font-size: 12px;
        color: #555;
      }
    }

    .node-label {
      font-size: 13px;
    }
  }

  .toggle {
    font: normal normal normal 18px/1 'Material Icons';
    color: #555;
    white-space: pre;
    margin-right: -15px;
    align-items: center;
    display: inline-flex;
    font-size: 21px;
    line-height: 1;

    &.collapsed::after {
      cursor: pointer;
      content: '\\E5CF';
      vertical-align: sub;
      width: 20px;
      text-align: center;
    }

    &.expanded::after {
      cursor: pointer;
      /* content: '-'; */
      content: '\\E5CE';
      vertical-align: sub;
      width: 20px;
      text-align: center;
    }
  }

  .node > label {
    margin-left: 20px;
    align-items: center;
    display: inline-flex;
  }

  /* checkbox styles */
  .checkbox-item {
    position: relative;
    width: 18px;
    height: 18px;
    margin-right: 0.75rem;
    cursor: pointer;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    outline: 0;
    vertical-align: middle;
    border: 2px solid #555;
    border-radius: 3px;
    box-sizing: border-box;

    &:checked {
      border: 9px solid #057bd4;
      animation: shrink-bounce 200ms cubic-bezier(0.4, 0, 0.23, 1);
    }

    &:checked:before {
      content: '';
      position: absolute;
      top: -3px;
      left: -6px;
      border-right: 3px solid transparent;
      border-bottom: 3px solid transparent;
      transform: rotate(45deg);
      transform-origin: 0% 100%;
      animation: checkbox-check 125ms 250ms cubic-bezier(0.4, 0, 0.23, 1) forwards;
      width: 12px;
      height: 24px;
      box-sizing: content-box;
    }
  }

  .dropdown-content {
    max-height: 350px;
    overflow: scroll;
    box-shadow: 0 0 10px rgb(0 0 0 / 10%);
    padding: 0 !important;

    ul.root {
      margin: 0;
      padding: 5px 0 5px 6px;

      .node {
        padding: 5px 15px 5px 0;
        display: flex;
        align-items: center;

        &.focused {
          background-color: transparent;
        }
      }
    }
  }

  .tag-list {
    display: flex;
    align-items: center;
    gap: 5px;
    flex-wrap: wrap;
    padding: 5px 0;
    margin-right: 3px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .tag-item {
    margin: 0;
    display: inline-block;
    font-family: 'Noto Sans', sans-serif;

    .tag {
      background-color: #eee;
      line-height: 1.6;
      padding: 3px 5px 3px 10px;
      word-break: break-word;
      white-space: pre-wrap;
      display: inline-block;
      border-radius: 20px;
      font-size: 11px;
      border: none;
    }
  }

  .tag-remove {
    background-color: #aeaeae;
    border: none;
    color: #fff;
    border-radius: 100%;
    font-size: 13px;
    padding: 1px 5px 3px;
    margin-left: 5px;
    text-align: center;
  }
`
